var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M618.552,13.278a7.127,7.127,0,0,0,.058-.878,5.386,5.386,0,0,0-.07-.877l1.956-1.485a.456.456,0,0,0,.116-.574L618.76,6.348a.477.477,0,0,0-.567-.2l-2.3.9a6.829,6.829,0,0,0-1.562-.878l-.347-2.385a.458.458,0,0,0-.463-.383h-3.7a.446.446,0,0,0-.451.383l-.347,2.385a7.01,7.01,0,0,0-1.562.878l-2.3-.9a.464.464,0,0,0-.567.2l-1.851,3.116a.428.428,0,0,0,.116.574l1.956,1.485a5.156,5.156,0,0,0-.012,1.755l-1.956,1.485a.456.456,0,0,0-.116.574l1.851,3.116a.477.477,0,0,0,.567.2l2.3-.9a6.828,6.828,0,0,0,1.562.878l.347,2.385a.467.467,0,0,0,.463.382h3.7a.438.438,0,0,0,.451-.382l.347-2.385a7.011,7.011,0,0,0,1.562-.878l2.3.9a.464.464,0,0,0,.567-.2l1.852-3.116a.428.428,0,0,0-.116-.574Zm-6.885,2.5a3.376,3.376,0,1,1,3.471-3.375A3.434,3.434,0,0,1,611.667,15.775Z",
    transform: "translate(-602.667 -3.4)",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.5367e6b927bb5b30b5613f50308cb6ac.svg";
export { ForwardRef as ReactComponent };